export const globalSettingsProductsJsdStatusRoute = {
	name: 'global-settings-products-jsd-status',
	path: '/plugins/servlet/ac/jsd-status-page',
};
